import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import englishServices from "../data/SdataEN";
import frenchServices from "../data/SdataFR";
import ServiceCard from "./ServiceCard";

const ServicesSection = ({ home }) => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState(
    i18n.language === "fr" ? frenchServices : englishServices
  );

 // const language = i18n.language;
  useEffect(() => {
    // Update service data whenever language changes
    setServices(i18n.language === "fr" ? frenchServices : englishServices);
  }, [i18n.language]);

  return (
    <section className="container my-5">
    {/*   {!home && (
        <div className="d-flex justify-content-center mb-4">
          <img
            src={imageSrc}
            className="img-fluid"
            alt="Services"
            style={{
              maxHeight: "400px",
              objectFit: "contain",
            }}
          />
        </div>
      )} */}
      <h2 className="text-center mb-4 text-black" ><strong style={{ color: "#4472c4" }}>{t("Our_Services_Title")}</strong></h2>
      <h2 className="text-center mb-4 text-black"><strong>STRATEDGE OUTSOURCING SOLUTIONS</strong> est une société basée au Luxembourg opérant dans trois domaines clés:</h2>
      <div className="row justify-content-center animate__animated animate__fadeInDown">
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            icon={service.icon}
            title={service.title}
            details={!home ? service.details : false}
            detailData={service.detailData}
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
